import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  stepContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.25),
    padding: theme.spacing(2),
    "&:last-child": {
      paddingBottom: theme.spacing(2),
    },
  },
  stepTitle: {
    fontWeight: 600,
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  groupHeaderContainer: {
    boxShadow: "none",
    "&.Mui-expanded": {
      margin: 0,
    },
    "& .MuiAccordionSummary-expandIcon": {
      padding: 0,
    },
    "& .MuiAccordionSummary-root": {
      gap: theme.spacing(2),
      minHeight: 0,
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
    "& .MuiButtonBase-root": {
      alignItems: "flex-start",
    },
    "& .MuiIconButton-label": {
      display: "block",
      lineHeight: 1,
    },
  },
  dateInformation: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    placeItems: "center",
    padding: theme.spacing(2),
    "& p": {
      lineHeight: 1,
    },
    '&[data-parity="odd"], &[data-parity="odd"] p': {
      background: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
    '&[data-parity="even"], &[data-parity="even"] p': {
      background: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
  day: {
    fontSize: "1.2rem",
  },
  month: {
    fontSize: "0.85rem",
  },
  SubGroupPanelContainer: {
    display: "flex",
    borderRadius: 12,
    overflow: "hidden",
    border: `1px solid ${theme.palette.programingOnDemandGrouped.headerBorder}`,
  },
  subGroupHeaderContainer: {
    flex: 1,
    boxShadow: "none",
    "&, &:first-child, &:last-child": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    "&.Mui-expanded": {
      margin: 0,
    },
    "& .MuiAccordionSummary-expandIcon": {
      padding: 0,
    },
    "& .MuiAccordionSummary-root": {
      gap: theme.spacing(2),
      minHeight: 0,
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
    "& .MuiButtonBase-root": {
      alignItems: "center",
    },
    "& .MuiIconButton-label": {
      display: "block",
      lineHeight: 1,
    },
  },
  groupPanelTitleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
    },
  },
  groupHeader: {
    fontWeight: 600,
    fontSize: "1.25rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.1rem",
    },
  },
  groupHeaderInfo: {
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-end",
    },
  },
  conditionContainer: {
    display: "flex",
    gap: theme.spacing(1),
    margin: theme.spacing(0, 1),
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      margin: 0,
    },
  },
  accordionButton: {
    alignItems: "flex-end",
    borderRadius: 20,
    padding: theme.spacing(0.7, 2),
    "& p": {
      lineHeight: 1.1,
      fontSize: "0.9rem",
    },
    "& .MuiButton-endIcon": {
      marginLeft: theme.spacing(0.5),
    },
    "& .MuiIcon-root": {
      fontSize: "1rem",
    },
  },
  watchButton: {
    alignItems: "flex-end",
    borderRadius: 20,
    padding: theme.spacing(0.7, 2),
    "& p": {
      lineHeight: 1.1,
      fontSize: "0.9rem",
    },
    "& .MuiButton-endIcon": {
      marginLeft: theme.spacing(0.5),
    },
    "& .MuiIcon-root": {
      fontSize: "1rem",
    },
    "&[data-watched-something=true], &[data-watched-something=true] p.MuiTypography-body1": {
      color: `${theme.palette.success.contrastText} !important`,
      backgroundColor: theme.palette.success.main,
    },
    "&[data-watched-something=false], &[data-watched-something=false] p.MuiTypography-body1": {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main,
    },
  },
  unavailableButton: {
    "& .MuiButton-label": {
      color: theme.palette.text.disabled,
    },
    "& .MuiIcon-root": {
      color: theme.palette.text.disabled,
    },
  },
}));
